import styled from 'styled-components';
import { AppBarItem } from 'ui-components/src/components/molecules/AppBarItem';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  height: 65px;
  display: flex;
  justify-content: flex-start;
`;

// Explicitly annotate the type of MenuAppBarItem
export const MenuAppBarItem = styled(AppBarItem as typeof AppBarItem)`
  padding: 0;
`;

export const MenuButton = styled.button`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary.white};
  border: 0;
  outline: 0;
  padding: 0 24px;
  cursor: pointer;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.97);
  }
`;

export const CenterContent = styled.div`
  order: 2;
  flex: 1;
`;
